export const state = () => ({
    isLoading: false,
    pendingRequests: 0
  })
  
  export const getters = {
    isLoading: state => state.isLoading
  }
  
  export const mutations = {
    START_REQUEST(state) {
      state.pendingRequests++
      state.isLoading = true
    },
    FINISH_REQUEST(state) {
      state.pendingRequests--
      if (state.pendingRequests <= 0) {
        state.isLoading = false
      }
    }
  }
  
  export const actions = {
    startRequest({ commit }) {
      commit('START_REQUEST')
    },
    finishRequest({ commit }) {
      commit('FINISH_REQUEST')
    }
  }